import { DictionaryText, Text } from '../../atoms'
import { InlineNotification, InlineNotificationProps } from '../../molecules'
import { NotificationVariant } from '../../../types'
import React, { Children, FC } from 'react'

const MESSAGE_KEYS = { HAS_ERRORS: 'STO.FORM.FORM_ERRORS.HAS_ERRORS' }

export interface ValidationErrorsProps
    extends Omit<InlineNotificationProps, 'message' | 'variant' | 'dismissable'>,
        Pick<React.HTMLAttributes<HTMLDivElement>, 'className'> {}

/**
 * Component meant to show a list of form validation errors
 *
 * @example
 *  <FormErrorSummary {...rest}>
 *       {yupErrors.map((error) => (
 *           <FormErrorListItem error={error} key={error.formInputId} />
 *       ))}
 *   </FormErrorSummary>
 */
export const FormErrorSummary: FC<ValidationErrorsProps> = ({ children, ...rest }) => {
    /** If no children, don't render anything */
    if (!children || !Children.toArray(children).filter((child) => !!child)?.length) return

    return (
        <InlineNotification
            {...rest}
            dismissable={false}
            data-testid="error-summary"
            variant={NotificationVariant.ERROR}
            message={
                <div className="text-shade-700">
                    <Text>
                        <DictionaryText textKey={MESSAGE_KEYS.HAS_ERRORS} />
                    </Text>
                    <ul className="list-disc list-inside">{children}</ul>
                </div>
            }
        />
    )
}
